<template>
  <div v-touch:swipe="swipeHandler">
    <div class="container-body">
      <div class="container-main">
        <div style="display: flex; justify-content: space-between">
          <div>
            <button @click="back()" class="custom-button">
              <i class="pi pi-chevron-left"></i>
            </button>
          </div>
          <div style="margin-top: 20px">
            {{ selectedWeek }}<i class="pi pi-calendar"></i>
          </div>
          <div>
            <button @click="next()" class="custom-button">
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>
        </div>
        <div v-if="workDays">
          <DataTable
            :value="workDays"
            :rowClass="rowClass"
            selectionMode="single"
            data-key="workDate"
            @row-click="onRowClick"
            @autoLayout="true" 
            responsiveLayour="scroll"
            breakpoint="350px"           
          >
            <Column
              field="workDate"
              :header="$t('Workday.Date')"
              headerStyle="width: 22%;"
            >
              <template #body="slotProps">
                <div
                  v-bind:class="{
                    red: slotProps.data.id === 0 && !slotProps.data.isWeekend,
                  }"
                >
                  {{ slotProps.data.workDate | formatDate }}
                </div>
              </template>
            </Column>
            <Column
              field="startTime"
              :header="$t('Workday.Start')"
              headerStyle="width: 22%;"
            >
              <template #body="slotProps">
                <div
                  v-bind:class="{
                    red: slotProps.data.id === 0 && !slotProps.data.isWeekend,
                  }"
                >
                  {{ slotProps.data.startTime | formatDateHourly }}
                </div>
              </template>
            </Column>
            <Column
              field="endTime"
              :header="$t('Workday.End')"
              headerStyle="width: 22%;"
            >
              <template #body="slotProps">
                <div
                  v-bind:class="{
                    red: slotProps.data.id === 0 && !slotProps.data.isWeekend,
                  }"
                >
                  {{ slotProps.data.endTime | formatDateHourly }}
                </div>
              </template>
            </Column>
            <Column field="isClosed" :header="$t('Workday.Close')">
              <template #body="slotProps">
                <div
                  v-bind:class="{
                    red: slotProps.data.id === 0 && !slotProps.data.isWeekend,
                  }"
                >
                  <i
                    v-if="slotProps.data.isClosed"
                    class="pi pi-check green"
                  ></i>
                  <i v-else class="pi pi-exclamation-circle red"></i>
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <!--<div>
        <button
          class="custom-mobile-button"
          @click="showConfirmationModalForStandardDay = true"
        >
          {{ $t("Workdays.AddStandardDay") }}
        </button>
      </div>-->
    </div>
    <DaySelector
      :display="showConfirmationModalForStandardDay"
      :disabledDays="disabledDays"
      @confirmed="onConfirmSelectedDay"
    ></DaySelector>
  </div>
</template>

<script>
import WorkDayService from "../services/WorkDayService";
import LocalStorageService from "../services/LocalStorageService";
import moment from "moment";
import { formatDateServer, getDateOfISOWeek } from "../utils";
import DaySelector from "../components/common/DaySelector";

export default {
  name: "WorkDays",
  workDayService: null,
  localStorageService: null,
  employee: null,
  startDate: Date,
  endDate: Date,
  components: { DaySelector },
  watch: {
    $route(to, from) {
      this.getCurrentWeekData();
    },
  },
  data() {
    return {
      workDays: null,
      selectedWeek: "",
      showConfirmationModalForStandardDay: false,
      loader: {},
      disabledDays: [],
    };
  },
  created() {
    this.workDayService = new WorkDayService();
    this.localStorageService = new LocalStorageService();
  },
  mounted() {
    this.employee = this.localStorageService.getCurrentEmployee();
    let dummyStartDate = new Date(this.$route.query.workDate);
    const dummyDays = new Date(this.$route.query.workDate).getDay() - 1;
    dummyStartDate = moment(dummyStartDate).subtract(dummyDays, "days");
    this.startDate = getDateOfISOWeek( moment(new Date(dummyStartDate)).isoWeek(), new Date(dummyStartDate).getFullYear());
    localStorage.setItem("selectedWeek", new Date(this.startDate));
    this.getCurrentWeekData();
  },
  methods: {
    rowClass(data) {
      return data.isValidEndTime ? "bg-light-red" : null;
    },
    getCurrentWeekData() {
      //Monday
      if(localStorage.getItem("selectedWeek") == null) {
        this.startDate = getDateOfISOWeek(
        moment(new Date()).isoWeek(),
        new Date().getFullYear()
        );
        this.endDate = moment(this.startDate).add(6, "days").toDate();
      }
      else {
        this.startDate = getDateOfISOWeek(
        moment(new Date(localStorage.getItem("selectedWeek"))).isoWeek(),
        new Date(localStorage.getItem("selectedWeek")).getFullYear()
        );
        this.endDate = moment(this.startDate).add(6, "days").toDate();
      }
      this.getWeek();
      this.getWorkDays();
    },
    getWorkDays() {
      const startDate = formatDateServer(this.startDate);
      const endDate = formatDateServer(this.endDate);
      this.loader = this.$loading.show({});
      this.workDayService
        .getWorkDays(startDate, endDate)
        .then((res) => {
          this.workDays = res.data;
          this.disabledDays = [];
          if (this.workDays && this.workDays.length > 0) {
            this.disabledDays = this.workDays
              .filter((s) => s.id !== 0)
              .map((s) => new Date(s.workDate).getDay());
          }
          this.showConfirmationModalForStandardDay = false;
          this.loader.hide();
        })
        .catch(() => {
          this.loader.hide();
        });
    },
    getWeek() {
        this.selectedWeek = `${this.startDate.getFullYear()} wk ${moment(
        this.startDate
        ).isoWeek()}`;
        localStorage.setItem("selectedWeek", new Date(this.startDate));
    },
    next: function () {
      this.startDate = moment(this.endDate).add(1, "days").toDate();
      this.endDate = moment(this.startDate).add(6, "days").toDate();
      this.getWeek();
      this.getWorkDays();
    },
    back: function () {
      this.endDate = moment(this.startDate).subtract(1, "days").toDate();
      this.startDate = moment(this.endDate).subtract(6, "days").toDate();
      this.getWeek();
      this.getWorkDays();
    },
    onRowClick(event) {
      const data = event.data;
      localStorage.setItem("selectedWorkDay", data.workDate)
      return this.$router.push({
        name: "work-day",
        query: { workDate: data.workDate },
      });
    },
    swipeHandler(direction) {
      if (process.env.VUE_APP_USE_SWIPE === "false") return;
      if (direction === "left") this.next();
      if (direction === "right") this.back();
    },
    onConfirmSelectedDay(event) {
      if (event.value) {
        let dates = event.days.map((s) =>
          formatDateServer(
            moment(this.startDate)
              .add(s - 1, "days")
              .toDate()
          )
        );
        this.createWorkDays(dates, event.dayType);
      }
      this.showConfirmationModalForStandardDay = false;
    },
    createWorkDays(workDates, dayType) {
      this.loader = this.$loading.show({});
      this.workDayService
        .createWorkDays(workDates, dayType)
        .then((res) => {
          this.workDays = res.data;
          this.loader.hide();
          this.getWorkDays();
        })
        .catch(() => {
          this.loader.hide();
        });
    },
  },
};
</script>
<style scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.bg-light-red {
  background-color: lightsalmon !important;
}
</style>
